import { ErrorCircleRegular } from '@fluentui/react-icons';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { TimetablePeriodSubstitutionInfoRowProps } from './TimetablePeriod.interface';
import { getSubstitutionMotiveText } from './TimetablePeriod.utils';
import { TimetablePeriodInfoRow } from './TimetablePeriodInfoRow';

/**
 * Renders an info row about the substitution taking place for a lesson
 * in the period details popup.
 */
export const TimetablePeriodSubstitutionInfoRow: FC<TimetablePeriodSubstitutionInfoRowProps> = ({
  substitution,
}) => {
  const { t } = useTranslation();
  const values = getSubstitutionMotiveText(substitution, t);

  return (
    <TimetablePeriodInfoRow
      icon={<ErrorCircleRegular className="substitutionExclamationIcon" />}
      label={t('timetable:period_info_row:substitution_info', { defaultValue: 'Vertretungs-Info' })}
      value={
        <div className="content">
          {values.map((value) => (
            <div key={value}>{value}</div>
          ))}
          {substitution.remark && <div>{substitution.remark}</div>}
        </div>
      }
    />
  );
};
